const priceTrim = (value: number): number => Math.round((value + Number.EPSILON) * 100) / 100;

// Price to be shown as a whole number or with a decimal value if not '.00'
const formatPrice = (price: number): string => priceTrim(price).toFixed(2).replace(/\.00$/, '');

// Same figure with the currency symbol, for prices that sit inside a sentence.
export const formatCurrency = (price: number): string => `£${formatPrice(price)}`;

export default formatPrice;
